enum ListType {
    Deals = "Deals",
    Leads = "Leads",
    LeaseComps = "LeaseComps",
    SaleComps = "SaleComps",
    Companies = "Companies",
    TenantsInMarket = "TenantsInMarket",
    Favorites = "Favorites",
    Notifications = "Notifications",
}

export default ListType;